import React, { Fragment, useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import TextField from "@material-ui/core/TextField";
import DateFnsUtils from "@date-io/date-fns";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import Parser from "html-react-parser";

// Material-UI Core
import { makeStyles, withStyles } from "@material-ui/core/styles";
// Custom Style
import { pasDetailFormStyle } from "../../../../styles/jss/components/PAS/pasDetailFormStyle";
const useStyles = makeStyles((theme) => pasDetailFormStyle(theme));

const PasDetails = (props) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const store = require("store");
  const { pasDetails, saleEditorValue, progressEditorValue } = props;

  return (
    <Fragment>
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <div className={classes.itemRoot}>
            <Typography variant="subtitle1" className={classes.itemHeader}>
              Project:
              <div className={classes.itemText}>{store.get("site_code")}</div>
            </Typography>
          </div>
        </Grid>
        <br />
        <Grid item xs={12}>
          <div className={classes.itemRoot}>
            <Typography variant="subtitle1" className={classes.itemHeader}>
              Construction Project Director:
              <div className={classes.itemText}>
                {pasDetails.details.con_manager}
              </div>
            </Typography>
          </div>
        </Grid>
        <Grid item xs={12}>
          <div className={classes.itemRoot}>
            <Typography variant="subtitle1" className={classes.itemHeader}>
              Construction Project Manager:
              <div className={classes.itemText}>
                {pasDetails.details.con_proj_manager}
              </div>
            </Typography>
          </div>
        </Grid>
        <Grid item xs={12}>
          <div className={classes.itemRoot}>
            <Typography variant="subtitle1" className={classes.itemHeader}>
              Client Project Manager:
              <div className={classes.itemText}>
                {pasDetails.details.client_proj_manager}
              </div>
            </Typography>
          </div>
        </Grid>
        <Grid item xs={12}>
          {pasDetails.details.sale_preparation !== null ||
          pasDetails.details.prog_qual_cost !== null ? (
            <Grid container spacing={0}>
              <Grid item xs={6} className={classes.contentBorder}>
                <Typography
                  variant="subtitle1"
                  className={classes.contentHeader}
                >
                  Sale Preparation Matters
                </Typography>
                <div style={{ margin: "10px" }}>
                  {pasDetails.details.sale_preparation === null
                    ? ""
                    : Parser(pasDetails.details.sale_preparation)}
                </div>
              </Grid>
              <Grid item xs={6} className={classes.contentBorder}>
                <Typography
                  variant="subtitle1"
                  className={classes.contentHeader}
                >
                  Progress / Quality / Cost Matters
                </Typography>

                <div style={{ margin: "10px" }}>
                  {pasDetails.details.prog_qual_cost === null
                    ? ""
                    : Parser(pasDetails.details.prog_qual_cost)}
                </div>
              </Grid>
            </Grid>
          ) : (
            <p>There are no PAS HighLights for this Project.</p>
          )}
        </Grid>
      </Grid>
    </Fragment>
  );
};

export default PasDetails;
